import { Box, Skeleton } from '@mui/material';
import React, { FC } from 'react';

const MembershipBenefitsSectionSkeleton: FC<any> = () => {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Box>
        <Box mb={4}>
          <Skeleton variant="rectangular" width={680} height={48} />
        </Box>
        {Array.from(new Array(6)).map((item) => (
          <Box key={item} mb={2}>
            <Skeleton
              variant="rectangular"
              width={600 + Math.random() * 400 - 200}
              height={28}
            />
          </Box>
        ))}

        <Box mt={4}>
          <Skeleton variant="rectangular" height={21} width={450} />
        </Box>
      </Box>
    </Box>
  );
};

export { MembershipBenefitsSectionSkeleton };